export const HTTP_TIMEOUT = process.env.REACT_APP_HTTP_TIMEOUT || 20000
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080'
export const IS_DEV = process.env.REACT_APP_IS_DEV